module.exports = __webpack_public_path__ + "static/media/Hugfimi-fill-side.8563572b.webp";